import React, { useEffect, useState } from 'react';
import { Input, Form, Button, Skeleton, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { editProfile, fetchProfile } from 'store/slices/customerSlice';
import AccountMenu from 'components/menu/AccountMenu';
import AccountLogoutButton from 'components/menu/AccountMenu/AccountLogoutButton';
import { loadingStatus } from 'helpers/fetcher';
import { setCustomer } from 'helpers/customer';

const Profile = () => {
  const { t } = useTranslation();
  const rules = [{ required: true, message: t('common.requiredField') }];
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
	const navigate = useNavigate();
	const { data, status } = useSelector(state => state.customer.profile);

	const handleFinish = async values => {
    setLoading(true);
    const res = await editProfile(values);
    if (res.error) {
      message.error(res.error_warning);
    } else {
      setCustomer(values);
      message.success(res.success);
    }
    setLoading(false);
  };

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  return (
		<div className="region account-section">
			{/* Breadcrumb */}
			<div className="contact-breadcrumb" style={{ marginTop: '64px' }}>
				<a
					href="/"
					onClick={e => {
						e.preventDefault();
						navigate('/');
					}}
					className="breadcrumb-link"
				>
				{t('common.home')}
			</a>
			<span className="breadcrumb-separator breadcrumb-separator-active"></span>
			<span className="breadcrumb-current">{t('account.personalAccount')}</span>
		</div>

		{/* Title */}
		<h1 className="account-title">{t('account.accountInfo')}</h1>

			{/* Layout */}
			<div className="account-layout">
				{/* Sidebar */}
				<div className="account-sidebar">
					<AccountMenu />
				</div>

				{/* Content */}
				<div className="account-content">
					<div className="account-form-card">
            {status === loadingStatus.SUCCEEDED ? (
              <Form
                name="profile"
                layout="vertical"
                initialValues={data}
                onFinish={handleFinish}
              >
              <Form.Item name="firstname" label={t('account.firstName')} rules={rules}>
              <Input />
              </Form.Item>
              <Form.Item name="lastname" label={t('account.lastName')} rules={rules}>
              <Input />
              </Form.Item>
							<Form.Item
								name="telephone"
								label={t('account.phoneNumber')}
								rules={rules}
							>
                <Input />
              </Form.Item>
							<Form.Item name="email" label={t('account.email')} rules={rules}>
              <Input />
              </Form.Item>
							<div className="account-form-submit">
                <Button type="primary" htmlType="submit" loading={loading}>
                  {t('account.saveChanges')}
                </Button>
								</div>
              </Form>
            ) : (
              <Skeleton active paragraph={{ rows: 6 }} />
            )}
          </div>
				</div>
			</div>

			{/* Кнопка выхода для мобильных */}
			<AccountLogoutButton />
    </div>
  );
};

export default Profile;
